import type { TelemetryEvent } from "../simulation/snapshot";

/** In-memory telemetry hooks for gates/metrics (no network required). */

export class TelemetrySink {
  private readonly events: TelemetryEvent[] = [];

  public ingest(batch: readonly TelemetryEvent[]): void {
    for (const event of batch) {
      this.events.push(event);
      if (this.events.length > 500) this.events.shift();
    }
  }

  public all(): readonly TelemetryEvent[] {
    return this.events;
  }

  public count(name: string): number {
    return this.events.filter((e) => e.name === name).length;
  }
}
